import isMobile from 'ismobilejs'
import React, { useState, useLayoutEffect } from 'react'
import { scroller } from 'react-scroll'
import VisibilitySensor from 'react-visibility-sensor'
import {
  Button,
  Counter,
  Container,
  Css,
  ExpandableButton,
  TextBody,
  TextTitle,
  Badge,
  ListContainer,
  // VariantList,
  Icon,
  Link,
  Tools,
  HtmlContent,
  Image,
  Select,
  BlockingLoader
} from '@pmi/pmi-iqos-ds-react'
import {
  analytics,
  htmlTranslation,
  BazaarVoice,
  Price,
  Sites,
  Badges
} from '@pmi/pmi-iqos-shared-react'
import {
  AddToCartButton,
  ProductCarousel,
  ShortestDeliveryDate,
  ProductDetailBar
} from '@zyn-common/components'

const imageBlockId = 'product-detail-images'
const actionBlockId = 'product-detail-actions'
const descriptionBlockId = 'product-detail-description'

const getDescriptionItem = (icon, text) => {
  return (
    <TextBody
      size={TextBody.sizes.m}
      data-testing="ProductDetail_TextBody_Description">
      <Icon size={Icon.sizes.s} image={icon} /> {text}
    </TextBody>
  )
}

const ProductDetailContent = ({
  product,
  options,
  selectedOptionIndex,
  quantity,
  loading,
  extraDataLoaded,
  showBar,
  bazaarVoiceReady,
  shortestDeliveryDate,
  addToCartHandler,
  addToPreorderHandler,
  colorChangeHandler,
  onQuantityChange,
  backgroundColor,
  translations,
  loadingButton,
  show3dModelBtn,
  isMulti,
  line,
  intensityChangeHandler
}) => {
  const [isBarVisible, setIsBarVisible] = useState(false)
  const [measuredDiff, setMeasuredDiff] = useState(null)
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false)
  const handleButtonVisibility = isBarVisible => {
    setIsBarVisible(!isBarVisible)
  }

  const handleReadMoreClick = () => {
    analytics.onSeeMoreDetailsClick(
      options[selectedOptionIndex].variantName,
      Sites.zyn
    )
    setIsDescriptionExpanded(!isDescriptionExpanded)
    if (isDescriptionExpanded) {
      scroller.scrollTo(actionBlockId, {
        duration: 0,
        smooth: true
      })
    }
  }

  const handleExpandProductClick = () => {
    analytics.onExpandProductClick(options[selectedOptionIndex].variantName)
  }

  const isReadMoreNecessary = () => {
    if (
      // (loading && !loadingButton) ||
      typeof document === 'undefined' ||
      typeof window === 'undefined'
    ) {
      return false
    }
    const imageBlock = document.getElementById(imageBlockId)
    const actionBlock = document.getElementById(actionBlockId)
    const descriptionBlock = document.getElementById(descriptionBlockId)
    if (Tools.isDesktop()) {
      // Desktop
      const readMoreNeeded =
        imageBlock &&
        actionBlock &&
        descriptionBlock &&
        actionBlock.scrollHeight + descriptionBlock.scrollHeight >
          imageBlock.scrollHeight // + 70  Little additional margin to prevent read more for 1 line
      return readMoreNeeded
    } else {
      const readMoreNeeded =
        descriptionBlock &&
        descriptionBlock.scrollHeight > (window.innerHeight * 50) / 100
      // 50vh
      return readMoreNeeded
    }
  }

  const getDescriptionHeight = () => {
    const imageBlock =
      typeof document !== 'undefined' && document.getElementById(imageBlockId)
    const actionBlock =
      typeof document !== 'undefined' && document.getElementById(actionBlockId)
    const diff =
      (imageBlock && imageBlock.scrollHeight) -
      (actionBlock && actionBlock.scrollHeight)
    return isDescriptionExpanded || !isReadMoreNecessary()
      ? 'auto'
      : ['50vh', '50vh', diff ? `calc(${diff}px - 2rem)` : '0']
  }

  useLayoutEffect(() => {
    const diff = getDescriptionHeight()
    setMeasuredDiff(diff)
  }, [isDescriptionExpanded])

  const variantNameClickHandler = () => {
    setIsBarVisible(false)
    scroller.scrollTo(imageBlockId, {
      duration: 0,
      smooth: true
    })
  }

  const handleDispatch3dOverlay = () => {
    analytics.on3DModeClick(options[selectedOptionIndex].variantName)
    window.dispatchEvent(
      new window.CustomEvent('player3d:show', {
        detail: {
          productId: product.id,
          variantId:
            options &&
            options[selectedOptionIndex] &&
            options[selectedOptionIndex].variantId
        }
      })
    )
  }
  const selectedOption = options && options[selectedOptionIndex]
  if (selectedOption) {
    const { price, listPrice, stock, images, description, descriptionLine } =
      selectedOption
    const bazaarVoice = product ? product.bv : null
    const bazaarVoiceProductId = selectedOption
      ? selectedOption.bv_id
      : bazaarVoice
      ? bazaarVoice.bv_id
      : null
    const bazaarVoiceShowRating =
      bazaarVoice &&
      bazaarVoice.display_rating === true &&
      bazaarVoiceProductId &&
      bazaarVoiceReady
    return (
      <Container position={Container.positions.relative} pt={['0', '5', '0']}>
        {line || (isBarVisible && showBar) ? (
          <ProductDetailBar
            id="ProductDetailBar"
            product={product}
            minQty={product.minQty}
            options={options}
            translations={translations}
            loading={loading}
            onAddToCart={addToCartHandler}
            onAddToPreorder={e => {
              analytics.notifyMe(
                'Click',
                'PDP Notify Me - Second',
                options[selectedOptionIndex].variantId,
                options[selectedOptionIndex].variantName
              )
              addToPreorderHandler(e)
            }}
            onVariantNameClick={variantNameClickHandler}
            selectedOptionIndex={selectedOptionIndex}
            line={line}
          />
        ) : null}
        {bazaarVoiceShowRating && <BazaarVoice.OverrideStyle />}
        <ListContainer columns={[1, 1, 2]} yBetween="6" xBetween="8">
          <Container fullWidth>
            <Container
              fullWidth
              position={Container.positions.relative}
              id={imageBlockId}>
              {!isMulti && selectedOption?.promotionalBadge && (
                <Css
                  s={
                    isMobile().any
                      ? {
                          width:
                            selectedOption.promotionalBadge.mobileWidth ||
                            'auto',
                          height:
                            selectedOption.promotionalBadge.mobileHeight ||
                            'auto',
                          position: 'absolute',
                          top:
                            selectedOption.promotionalBadge.mobileTopMargin ||
                            '0',
                          right:
                            selectedOption.promotionalBadge.mobileRightMargin ||
                            '0'
                        }
                      : {
                          width:
                            selectedOption.promotionalBadge.desktopWidth ||
                            'auto',
                          height:
                            selectedOption.promotionalBadge.desktopHeight ||
                            'auto',
                          position: 'absolute',
                          top:
                            selectedOption.promotionalBadge.desktopTopMargin ||
                            '0',
                          right:
                            selectedOption.promotionalBadge
                              .desktopRightMargin || '0'
                        }
                  }>
                  <Image
                    width="full"
                    src={selectedOption.promotionalBadge.url_pdp}
                  />
                </Css>
              )}
              <ProductCarousel
                images={images}
                videos={product.videos}
                prodImages={product.prodImages}
                onFullScreenHandler={handleExpandProductClick}
              />
              {show3dModelBtn ? (
                <Container
                  pb="6"
                  b="0"
                  fullWidth
                  position={Container.positions.absolute}
                  display={Container.displays.flex}
                  justifyContent={Container.justifyContentValues.center}>
                  <Button
                    variant={Button.variants.secondary}
                    text={translations.tk_3dModel}
                    onClickHandler={handleDispatch3dOverlay}
                  />
                </Container>
              ) : null}
            </Container>
          </Container>
          <Container
            fullWidth
            itemid={options ? options[selectedOptionIndex].variantId : null}
            px={['0', '0', '24']}>
            <Css
              s={{
                overflow: 'hidden',
                position: 'relative',
                '::after': isReadMoreNecessary() && {
                  content: '""',
                  position: 'absolute',
                  height: '1rem',
                  bottom: 0,
                  left: '-1rem',
                  right: '-1rem',
                  boxShadow: isDescriptionExpanded
                    ? 'none'
                    : `inset ${backgroundColor} 0 -1rem 1rem`
                }
              }}>
              <Container id={actionBlockId}>
                {(product.family || selectedOption.badges) && (
                  <Badges
                    badges={
                      product.family
                        ? selectedOption.badges &&
                          selectedOption.badges.slice(0, 2)
                        : selectedOption.badges
                    }
                    testingPrefix="ProductDetail_Badge_ProductHint">
                    {product.family && (
                      <Container overflowHidden>
                        <Badge
                          text={product.family.name}
                          color={product.family.colour}
                          border
                          data-testing="ProductDetail_Badge_ProductFamily"
                        />
                      </Container>
                    )}
                  </Badges>
                )}
                <Container display={Container.displays.flex} pb="4">
                  <TextTitle
                    heading={TextTitle.headings.h3}
                    additionalClasses="q-text-turquoise"
                    data-testing="ProductDetail_TextTitle_ProductName">
                    {product.name || translations.tk_productName}
                  </TextTitle>
                </Container>
                <Container pb="8">
                  {/* {options[selectedOptionIndex].shortVariantName &&
                    options[selectedOptionIndex].shortVariantName.length >
                      0 && (
                      <Container pb="4">
                        <TextBody
                          size={TextBody.sizes.m}
                          data-testing="ProductDetail_TextBody_ShortVariantName">
                          {options[selectedOptionIndex].shortVariantName}
                        </TextBody>
                      </Container>
                    )}
                  <VariantList
                    variants={options}
                    selectedVariantIndex={selectedOptionIndex}
                    handleVariantIndexChange={colorChangeHandler}
                    data-testing-prefix="ProductDetail"
                  /> */}
                </Container>
                {bazaarVoiceShowRating && (
                  <Container pb="6">
                    <BazaarVoice
                      type={BazaarVoice.types.ratingSummary}
                      productId={bazaarVoiceProductId}
                      data-testing-prefix="ProductDetail"
                    />
                  </Container>
                )}
                {options[selectedOptionIndex].shortDescription &&
                  options[selectedOptionIndex].shortDescription.length > 0 && (
                    <Container pb="6">
                      <Css
                        s={{
                          ol: {
                            listStyle: 'auto !important',
                            padding: 'revert !important'
                          },
                          ul: {
                            listStyle: 'unset !important',
                            padding: 'revert !important'
                          }
                        }}>
                        <TextBody
                          size={TextBody.sizes.m}
                          data-testing="ProductDetail_TextBody_ShortDescription"
                          acceptsHtml
                          value={options[selectedOptionIndex].shortDescription}
                        />
                      </Css>
                    </Container>
                  )}
                <VisibilitySensor
                  partialVisibility
                  resizeCheck
                  offset={{
                    top: 36,
                    bottom: -1000000000
                  }}
                  onChange={handleButtonVisibility}>
                  <Container pb="4">
                    <Price
                      size={Price.sizes.large}
                      listPrice={listPrice}
                      price={price}
                      currency={product.currency}
                      listPriceLabel={translations.tk_listPriceDescription}
                      discountedPriceLabel={
                        translations.tk_discountedPriceDescription
                      }
                      taxLabel={translations.tk_withTax}
                      data-testing="ProductDetail_Price"
                    />
                  </Container>
                </VisibilitySensor>
                {!stock && extraDataLoaded && (
                  <Container pb="4">
                    <TextBody
                      style={TextBody.styles.error}
                      {...htmlTranslation(translations, 'tk_outOfStock')}
                    />
                  </Container>
                )}
                {extraDataLoaded ? (
                  <Container>
                    <Container pr={['5', '7']} pb={'5'}>
                      <Select
                        size={Select.sizes.s}
                        value={String(selectedOptionIndex)}
                        name={'intensity'}
                        label={translations.tk_selectIntensity}
                        items={options}
                        getItemLabel={(index, item) => item.shortVariantName}
                        getItemValue={(index, item) => index}
                        onChangeHandler={e =>
                          intensityChangeHandler(e.target.value)
                        }
                      />
                    </Container>
                    <Container
                      pb="8"
                      display={Container.displays.flex}
                      alignItems={Container.alignItemsValues.center}
                      flexDirection={Container.flexDirections.row}>
                      {!!stock && (
                        <Container pr="6">
                          <Counter
                            quantity={quantity}
                            minQty={product.minQty}
                            maxQty={product.maxQty}
                            quantityChangeHandler={onQuantityChange}
                            data-testing-prefix="ProductDetail"
                          />
                        </Container>
                      )}
                      <AddToCartButton
                        maxQty={product.maxQty}
                        hasStock={!!stock}
                        addToCartHandler={addToCartHandler}
                        addToPreorderHandler={e => {
                          analytics.notifyMe(
                            'Click',
                            'PDP Notify Me - First',
                            options[selectedOptionIndex].variantId,
                            options[selectedOptionIndex].variantName
                          )
                          addToPreorderHandler(e)
                        }}
                        loading={loadingButton}
                        addToCartLabel={translations.tk_buttonAddToCart}
                        addToPreorderLabel={translations.tk_buttonAddToPreorder}
                        addToPreorderLabelDisabled={
                          translations.tk_buttonAddToPreorderDisabled
                        }
                        outOfStockAction={product.outOfStockAction}
                        data-testing="ProductDetail_Button_AddToCart"
                      />
                    </Container>
                  </Container>
                ) : (
                  <BlockingLoader loading />
                )}
                {product.subscriptionLinkText &&
                  product.subscriptionLinkUrl && (
                    <Container pb="4">
                      <Link
                        href={product.subscriptionLinkUrl}
                        data-testing="ProductDetail_Link_Subscription"
                        underline={false}>
                        {getDescriptionItem(
                          Icon.images.wallet,
                          product.subscriptionLinkText
                        )}
                      </Link>
                    </Container>
                  )}
                {product.promotionBanner && (
                  <Container pb="6">
                    <HtmlContent content={product.promotionBanner} />
                  </Container>
                )}
                {((product.preorderable && shortestDeliveryDate === '') ||
                  shortestDeliveryDate) && (
                  <Container pb="4">
                    <ShortestDeliveryDate
                      shortestDeliveryDate={
                        product.preorderable ? '' : shortestDeliveryDate
                      }
                      shortestDateLabel={
                        product.preorderable
                          ? translations.tk_preorderableDate
                          : translations.tk_shortestDateLabel
                      }
                      shortestDateNote={translations.tk_shortestDateNote}
                    />
                  </Container>
                )}
                {product.attributes && product.attributes.length > 0 && (
                  <Container pb="4">
                    <ListContainer yBetween="4" columns={1}>
                      {product.attributes.map((attribute, index) => (
                        <Container key={index}>
                          {getDescriptionItem(
                            Icon.images.confirmation,
                            attribute
                          )}
                        </Container>
                      ))}
                    </ListContainer>
                  </Container>
                )}
              </Container>
              <Container pb="8">
                <Css
                  id={descriptionBlockId}
                  s={{
                    height: measuredDiff,
                    minHeight: '6rem',
                    ol: {
                      listStyle: 'auto !important',
                      padding: 'revert !important'
                    },
                    ul: {
                      listStyle: 'unset !important',
                      padding: 'revert !important'
                    }
                  }}>
                  {(description || line) && (
                    <TextBody
                      acceptsHtml
                      value={
                        line ? descriptionLine || description : description
                      }
                      data-testing={`ProductDetail_TextBody_Description${
                        line ? '_Line' : ''
                      }`}
                    />
                  )}
                </Css>
              </Container>
            </Css>
            {isReadMoreNecessary() && (
              <ExpandableButton
                onClickHandler={handleReadMoreClick}
                icon={
                  isDescriptionExpanded
                    ? Icon.images.chevronUp
                    : Icon.images.chevronDown
                }
                iconPosition={ExpandableButton.iconPositions.right}
                textTemplate={
                  <TextBody
                    size={TextBody.sizes.m}
                    {...htmlTranslation(
                      translations,
                      isDescriptionExpanded ? 'tk_readLess' : 'tk_readMore'
                    )}
                  />
                }
                data-testing="ProductDetail_Button_ReadMore"
              />
            )}
          </Container>
        </ListContainer>
      </Container>
    )
  } else {
    return null
  }
}

export default ProductDetailContent
